"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MoveUp: ['move-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 0.748L12 11.248', 'M8.25 4.498L12 0.748 15.75 4.498', 'M0.750 15.748 L23.250 15.748 L23.250 23.248 L0.750 23.248 Z']],
  MoveRight1: ['move-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75 11.998L0.75 11.998', 'M15 8.248L18.75 11.998 15 15.748', 'M23.25 0.748L23.25 23.248']],
  MoveUp1: ['move-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 5.248L12 23.248', 'M8.25 8.998L12 5.248 15.75 8.998', 'M0.75 0.748L23.25 0.748']],
  CursorMoveDown: ['cursor-move-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.48,22.9l-3.44-9.25a.537.537,0,0,1,.766-.63L12,14.516l3.194-1.494a.537.537,0,0,1,.766.63L12.52,22.9A.564.564,0,0,1,11.48,22.9Z', 'M17.249,18.716a9.75,9.75,0,1,0-10.5,0']],
  CursorMoveLeft: ['cursor-move-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.1,12.518l9.249,3.44a.537.537,0,0,0,.63-.766L9.482,12,10.975,8.8a.538.538,0,0,0-.63-.767L1.1,11.478A.564.564,0,0,0,1.1,12.518Z', 'M5.282,6.749a9.75,9.75,0,1,1,0,10.5']],
  CursorMoveRight: ['cursor-move-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.9,11.478l-9.249-3.44a.537.537,0,0,0-.63.766L14.518,12l-1.493,3.194a.537.537,0,0,0,.63.766l9.249-3.44A.564.564,0,0,0,22.9,11.478Z', 'M18.718,17.247a9.75,9.75,0,1,1,0-10.5']],
  CursorMoveTargetRight: ['cursor-move-target-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.750 11.998 A3.750 3.750 0 1 0 23.250 11.998 A3.750 3.750 0 1 0 15.750 11.998 Z', 'M19.5,11.623a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M10.5 9.748L12.75 11.998 10.5 14.248', 'M5.25 11.998L12.75 11.998', 'M19.293,5.247a10.5,10.5,0,1,0,0,13.5']],
  CursorMoveUp: ['cursor-move-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.48,1.094,8.04,10.343a.537.537,0,0,0,.766.63L12,9.479l3.194,1.494a.537.537,0,0,0,.766-.63L12.52,1.094A.563.563,0,0,0,11.48,1.094Z', 'M17.249,5.28a9.75,9.75,0,1,1-10.5,0']],
  DirectionButton: ['direction-button', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5,4.808l3.75-3.75a1.061,1.061,0,0,1,1.5,0l3.75,3.75', 'M4.811,16.5l-3.75-3.75a1.059,1.059,0,0,1,0-1.5L4.811,7.5', 'M16.5,19.187l-3.75,3.75a1.061,1.061,0,0,1-1.5,0L7.5,19.187', 'M19.189,7.5l3.75,3.75a1.061,1.061,0,0,1,0,1.5l-3.75,3.75', 'M9.000 11.998 A3.000 3.000 0 1 0 15.000 11.998 A3.000 3.000 0 1 0 9.000 11.998 Z']],
  ScrollHorizontal: ['scroll-horizontal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 11.998 A2.250 2.250 0 1 0 14.250 11.998 A2.250 2.250 0 1 0 9.750 11.998 Z', 'M6.311,18l-5.25-5.25a1.059,1.059,0,0,1,0-1.5L6.311,6', 'M17.689,6l5.25,5.25a1.061,1.061,0,0,1,0,1.5L17.689,18']],
  ScrollHorizontal1: ['scroll-horizontal-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.000 12.088 A3.000 3.000 0 1 0 15.000 12.088 A3.000 3.000 0 1 0 9.000 12.088 Z', 'M1.026,11.459a.854.854,0,0,0,0,1.257l3.118,2.858a.66.66,0,0,0,1.106-.486v-6A.66.66,0,0,0,4.144,8.6Z', 'M22.973,12.716a.852.852,0,0,0,0-1.257L19.856,8.6a.66.66,0,0,0-1.106.487v6a.659.659,0,0,0,1.105.486Z']],
  ScrollVertical: ['scroll-vertical', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 11.998 A2.250 2.250 0 1 0 14.250 11.998 A2.250 2.250 0 1 0 9.750 11.998 Z', 'M6,6.308l5.25-5.25a1.061,1.061,0,0,1,1.5,0L18,6.308', 'M18,17.687l-5.25,5.25a1.061,1.061,0,0,1-1.5,0L6,17.687']],
  ScrollVertical1: ['scroll-vertical-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.090 11.998 A3.000 3.000 0 1 0 15.090 11.998 A3.000 3.000 0 1 0 9.090 11.998 Z', 'M12.718,1.024a.854.854,0,0,0-1.257,0L8.6,4.142A.66.66,0,0,0,9.09,5.248h6a.66.66,0,0,0,.486-1.106Z', 'M11.461,22.971a.852.852,0,0,0,1.257,0l2.858-3.118a.659.659,0,0,0-.486-1.105h-6A.66.66,0,0,0,8.6,19.853Z']],
  MoveLeftRight: ['move-left-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,14.248H21.439a.751.751,0,0,1,.531,1.281L18,19.5', 'M6,4.5,2.03,8.468a.75.75,0,0,0,.531,1.28H23.25']],
  MoveTopRight: ['move--top-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,4.5H18.75a.75.75,0,0,1,.75.75V19.5']],
  MoveExpandVertical: ['move-expand-vertical', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75,15l7.72,7.72a.751.751,0,0,0,1.06,0L20.25,15', 'M3.75,9l7.72-7.72a.749.749,0,0,1,1.06,0L20.25,9']],
  MoveLeft1: ['move-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25 11.998L23.25 11.998', 'M9 8.248L5.25 11.998 9 15.748', 'M0.75 0.748L0.75 23.248']],
  MoveToBottom: ['move-to-bottom', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 0.748H6.75V6.748H0.75z', 'M0.75 10.498L0.75 9.748 2.25 9.748', 'M2.25 14.248L0.75 14.248 0.75 13.498', 'M6.75 13.498L6.75 14.248 5.25 14.248', 'M2.25 23.248L0.75 23.248 0.75 21.748', 'M6.75 21.748L6.75 23.248 5.25 23.248', 'M5.25 9.748L6.75 9.748 6.75 10.498', 'M0.75 18.748L0.75 17.248 2.25 17.248', 'M5.25 17.248L6.75 17.248 6.75 18.748', 'M15 15.748L11.25 19.498 15 23.248', 'M11.25,19.5h4.5a7.5,7.5,0,0,0,0-15h-4.5']],
  MoveToTop: ['move-to-top', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 17.248H6.75V23.248H0.75z', 'M0.75 13.498L0.75 14.248 2.25 14.248', 'M2.25 9.748L0.75 9.748 0.75 10.498', 'M6.75 10.498L6.75 9.748 5.25 9.748', 'M2.25 0.748L0.75 0.748 0.75 2.248', 'M6.75 2.248L6.75 0.748 5.25 0.748', 'M5.25 14.248L6.75 14.248 6.75 13.498', 'M0.75 5.248L0.75 6.748 2.25 6.748', 'M5.25 6.748L6.75 6.748 6.75 5.248', 'M15 8.248L11.25 4.498 15 0.748', 'M11.25,4.5h4.5a7.5,7.5,0,0,1,0,15h-4.5']],
  MoveRight: ['move-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 11.998L12.75 11.998', 'M19.5 15.748L23.25 11.998 19.5 8.248', 'M0.750 0.748 L8.250 0.748 L8.250 23.248 L0.750 23.248 Z']],
  MoveTopLeft: ['move-top-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,19.5V5.248a.75.75,0,0,1,.75-.75H19.5']],
  CursorMoveTargetLeft: ['cursor-move-target-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.998 A3.750 3.750 0 1 0 8.250 11.998 A3.750 3.750 0 1 0 0.750 11.998 Z', 'M4.5,11.623A.375.375,0,1,1,4.125,12a.375.375,0,0,1,.375-.375', 'M13.5 14.248L11.25 11.998 13.5 9.748', 'M18.75 11.998L11.25 11.998', 'M4.707,18.748a10.5,10.5,0,1,0,0-13.5']],
  DirectionButtonArrows: ['direction-button-arrows', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9 3.748L12 0.748 15 3.748', 'M15 20.248L12 23.248 9 20.248', 'M12 0.748L12 23.248', 'M3.75 14.998L0.75 11.998 3.75 8.998', 'M20.25 8.998L23.25 11.998 20.25 14.998', 'M0.75 11.998L23.25 11.998']],
  CursorMoveTargetUp: ['cursor-move-target-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.250 4.498 A3.750 3.750 0 1 0 15.750 4.498 A3.750 3.750 0 1 0 8.250 4.498 Z', 'M12,4.873a.375.375,0,1,1,.375-.375A.375.375,0,0,1,12,4.873', 'M9.75 13.498L12 11.248 14.25 13.498', 'M12 18.748L12 11.248', 'M5.249,4.705a10.5,10.5,0,1,0,13.5,0']],
  CursorMoveTargetDown: ['cursor-move-target-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.250 19.498 A3.750 3.750 0 1 0 15.750 19.498 A3.750 3.750 0 1 0 8.250 19.498 Z', 'M12,19.123a.375.375,0,1,1-.375.375A.375.375,0,0,1,12,19.123', 'M14.25 10.498L12 12.748 9.75 10.498', 'M12 5.248L12 12.748', 'M18.75,19.29a10.5,10.5,0,1,0-13.5,0']],
  CursorMoveDirection: ['cursor-move-direction', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.998 A11.250 11.250 0 1 0 23.250 11.998 A11.250 11.250 0 1 0 0.750 11.998 Z', 'M9.000 11.998 A3.000 3.000 0 1 0 15.000 11.998 A3.000 3.000 0 1 0 9.000 11.998 Z', 'M5.133 10.614L3.75 11.998 5.133 13.381', 'M10.616 18.864L12 20.248 13.383 18.864', 'M13.383 5.131L12 3.748 10.616 5.131', 'M18.866 13.381L20.25 11.998 18.866 10.614']],
  DirectionButton1: ['direction-button-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,6.748h-3a1.5,1.5,0,0,1-1.5-1.5v-3a1.5,1.5,0,0,0-1.5-1.5H8.25a1.5,1.5,0,0,0-1.5,1.5v3a1.5,1.5,0,0,1-1.5,1.5h-3a1.5,1.5,0,0,0-1.5,1.5v7.5a1.5,1.5,0,0,0,1.5,1.5h3a1.5,1.5,0,0,1,1.5,1.5v3a1.5,1.5,0,0,0,1.5,1.5h7.5a1.5,1.5,0,0,0,1.5-1.5v-3a1.5,1.5,0,0,1,1.5-1.5h3a1.5,1.5,0,0,0,1.5-1.5v-7.5A1.5,1.5,0,0,0,21.75,6.748Z', 'M9.75 5.998L12 3.748 14.25 5.998', 'M14.25 17.998L12 20.248 9.75 17.998', 'M6 14.248L3.75 11.998 6 9.748', 'M18 9.748L20.25 11.998 18 14.248']],
  MoveDown: ['move-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 23.248L12 12.748', 'M8.25 19.498L12 23.248 15.75 19.498', 'M0.750 0.748 L23.250 0.748 L23.250 8.248 L0.750 8.248 Z']],
  CrossOver: ['cross-over', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 0.748L0.75 23.248', 'M23.25 7.498L23.25 0.748 16.5 0.748', 'M0.75 0.748L9 8.998', 'M23.25 16.498L23.25 23.248 16.5 23.248', 'M15 14.998L23.25 23.248']],
  MoveShrinkVertical: ['move--shrink-vertical', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75.748l7.72,7.72a.749.749,0,0,0,1.06,0L20.25.748', 'M3.75,23.248l7.72-7.719a.749.749,0,0,1,1.06,0l7.72,7.719']],
  MoveBottomLeft: ['move-bottom-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5,19.5H5.25a.75.75,0,0,1-.75-.75V4.5']],
  MoveLeft: ['move-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 11.998L11.25 11.998', 'M4.5 8.248L0.75 11.998 4.5 15.748', 'M15.750 0.748 L23.250 0.748 L23.250 23.248 L15.750 23.248 Z']],
  MoveBack: ['move-back', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6 4.498L0.75 9.748 6 14.998', 'M.75,9.748h21a1.5,1.5,0,0,1,1.5,1.5v9']],
  MoveBottomRight: ['move-bottom-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5,4.5v14.25a.75.75,0,0,1-.75.75H4.5']],
  MoveDown1: ['move-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 18.748L12 0.748', 'M8.25 14.998L12 18.748 15.75 14.998', 'M0.75 23.248L23.25 23.248']],
  DirectionButtonSquare: ['direction-button-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.748 L23.250 0.748 L23.250 23.248 L0.750 23.248 Z', 'M14.25 5.998L12 3.748 9.75 5.998', 'M9.75 17.998L12 20.248 14.25 17.998', 'M6 9.748L3.75 11.998 6 14.248', 'M18 14.248L20.25 11.998 18 9.748']],
  DirectionButton2: ['direction-button-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.000 11.998 A3.000 3.000 0 1 0 15.000 11.998 A3.000 3.000 0 1 0 9.000 11.998 Z', 'M1.026,11.369a.854.854,0,0,0,0,1.257l3.118,2.858A.66.66,0,0,0,5.25,15V9a.66.66,0,0,0-1.106-.486Z', 'M22.973,12.626a.852.852,0,0,0,0-1.257L19.856,8.511A.66.66,0,0,0,18.75,9v6a.659.659,0,0,0,1.105.486Z', 'M11.372,22.971a.85.85,0,0,0,1.256,0l2.858-3.118A.659.659,0,0,0,15,18.748H9a.66.66,0,0,0-.487,1.105Z', 'M12.628,1.024a.852.852,0,0,0-1.256,0L8.514,4.142A.66.66,0,0,0,9,5.248h6a.66.66,0,0,0,.486-1.106Z']],
  DirectionButton3: ['direction-button-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,23.248h-3a1.5,1.5,0,0,1-1.5-1.5v-4.19a.752.752,0,0,1,.219-.53l2.25-2.25a.75.75,0,0,1,1.061,0l2.25,2.25a.749.749,0,0,1,.22.53v4.19A1.5,1.5,0,0,1,13.5,23.248Z', 'M10.5.748h3a1.5,1.5,0,0,1,1.5,1.5V6.437a.747.747,0,0,1-.22.53l-2.25,2.25a.75.75,0,0,1-1.061,0l-2.25-2.25A.75.75,0,0,1,9,6.437V2.248A1.5,1.5,0,0,1,10.5.748Z', 'M23.25,10.5v3a1.5,1.5,0,0,1-1.5,1.5H17.561a.751.751,0,0,1-.531-.22l-2.25-2.25a.75.75,0,0,1,0-1.061l2.25-2.25A.754.754,0,0,1,17.561,9H21.75A1.5,1.5,0,0,1,23.25,10.5Z', 'M.75,14.248v-4.5A.75.75,0,0,1,1.5,9H6.439a.75.75,0,0,1,.53.219l2.25,2.25a.75.75,0,0,1,0,1.061l-2.25,2.25a.747.747,0,0,1-.53.22H1.5A.75.75,0,0,1,.75,14.248Z']]
};
exports["default"] = _default;